var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.dsf.global.$isMobile)?_c('div',{staticClass:"ds-empty-data"},[_c('DsfIcon',{attrs:{"name":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1):_c('van-empty',{attrs:{"image":_vm.image,"description":_vm.description,"image-size":_vm.imageSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }